module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/5/1-41e4a9345312df0e1fa40492b85480e2.jpg";